import { render, staticRenderFns } from "./KycIndex.vue?vue&type=template&id=79b5a00c&scoped=true"
import script from "./KycIndex.vue?vue&type=script&lang=js"
export * from "./KycIndex.vue?vue&type=script&lang=js"
import style0 from "./KycIndex.vue?vue&type=style&index=0&id=79b5a00c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b5a00c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b5a00c')) {
      api.createRecord('79b5a00c', component.options)
    } else {
      api.reload('79b5a00c', component.options)
    }
    module.hot.accept("./KycIndex.vue?vue&type=template&id=79b5a00c&scoped=true", function () {
      api.rerender('79b5a00c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/kyc/KycIndex.vue"
export default component.exports